/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ContactRoleWithRelations } from '../models/contact-role-with-relations';
import { getContactRolesList } from '../fn/editor-contact-role-controller/get-contact-roles-list';
import { GetContactRolesList$Params } from '../fn/editor-contact-role-controller/get-contact-roles-list';

@Injectable({ providedIn: 'root' })
export class EditorContactRoleControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contactRoleControllerGetContactRolesList()` */
  static readonly ContactRoleControllerGetContactRolesListPath = '/editor/contact-roles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContactRolesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactRolesList$Response(params: GetContactRolesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactRoleWithRelations>>> {
    return getContactRolesList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContactRolesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactRolesList(params: GetContactRolesList$Params, context?: HttpContext): Observable<Array<ContactRoleWithRelations>> {
    return this.getContactRolesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ContactRoleWithRelations>>): Array<ContactRoleWithRelations> => r.body)
    );
  }

}
